import { Button, Modal } from 'antd';
import { useState } from 'react';
import ProgressBar from '../Progress/Progress';
const ModalProgress = (props) => {
    const { progress, setProgress, modalOpen ,onClick} = props

    return (
        <>
            <div className='Button_div '  onClick={onClick}>
                <Button className='Main_button' type="primary" >
                    Terminer
                </Button>
            </div>
            <Modal width={400} title="Estimation en cours...." footer={null} closable={false} open={modalOpen} >
                <ProgressBar modalOpen={modalOpen} setProgress={setProgress} progress={progress} />
            </Modal>
        </>
    );
};
export default ModalProgress;